import { Routes, Route } from "react-router-dom";
import { PublicRoutes } from "./PublicRoutes";
import { PrivateRoutes } from "./PrivateRoutes";
import RootRedirect from "./RootRedirect";
import Unauthorized from "../pages/Unauthorized";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      {PublicRoutes}
      {PrivateRoutes}
    </Routes>
  );
}
